import { Pipe, PipeTransform } from '@angular/core';
import {
    EntityMasterFieldsModel,
    MasterFieldsMergingMetadataModel,
    MasterFieldsMergingRule
} from '@app/views/admin/application-settings/models/master-fields.model';

@Pipe({
    name: 'availableMergingMetadataModelListPipe'
})
export class AvailableMergingMetadataModelListPipe implements PipeTransform {

    transform(entityData: EntityMasterFieldsModel,
        currentPropertyName: string,
        availableMergingMetadataModelList: MasterFieldsMergingMetadataModel[]
    ): MasterFieldsMergingMetadataModel[] {

        if (entityData.mergingRuleList && entityData.mergingRuleList.length > 0) {
            return entityData.mergingMetadataModelList
                .filter((mergingMetadata: MasterFieldsMergingMetadataModel) =>
                    (currentPropertyName === mergingMetadata.propertyName)
                    || !entityData.mergingRuleList.some((existedMergingRule: MasterFieldsMergingRule) => existedMergingRule.propertyName === mergingMetadata.propertyName)
                );
        } else {
            return entityData.mergingMetadataModelList;
        }
    }

}
